import { singletonHook } from "react-singleton-hook";

const initialIsDemo = new URLSearchParams(window.location.search).has('demo');
export const useIsDemo = singletonHook<boolean>(initialIsDemo, (): boolean => {
    return initialIsDemo;
});